import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { PageContentContainer } from '~src/styles/containers.sc';
import { media } from '~src/styles/media-templates';

export const MsgWrapper = styled.span`
  padding: 1rem 3rem 1rem 1rem;
  display: flex;
  letter-spacing: 0.3px;
  align-items: center;
  width: auto;
  float: right;
  justify-content: center;
  line-height: 0;
  ${media.phone`
    padding-right: 15px;
  `}
`;

export const MsgContainer = styled.span`
  font-size: 1rem;
  color: ${({ theme }) => theme.baseBlue.a6};
  letter-spacing: 0.3px;
  margin-right: 10px;
  white-space: nowrap;
  ${media.phone`
    display: none;
  `}
`;

export const LogoLink = styled(Link)`
  float: none;
`;

export const HeaderContainer = styled(PageContentContainer)`
  padding: 0;
`;

export const HeaderImg = styled.img<{ $newLogin: boolean }>`
  height: 50px;
  color: ${({ theme, $newLogin }) => ($newLogin ? theme.baseBlue.a10 : theme.white.a10)};
  margin: 0 30px 0 15px;
`;

export const LoginSecondaryButton = styled.button`
  border-radius: 100px;
  cursor: pointer;
  transition: all 0.3s ease-in;
  background-color: rgba(0, 0, 0, 0);
  border: 1px solid ${({ theme }) => theme.brandRed.a10};
  padding: 4px 2rem;
  margin: 0;
  width: 100%;
  font-size: 15px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.3px;
  text-align: center;
  color: ${({ theme }) => theme.brandRed.a10};
  box-shadow: none;
  text-transform: none;
  white-space: nowrap;

  &:active {
    box-shadow: none;
  }

  &:hover {
    box-shadow: none;
    background-color: ${({ theme }) => theme.brandRed.a10};
    color: ${({ theme }) => theme.white.a10};
  }

  &:focus {
    box-shadow: none;
  }
`;

export const LoginLink = styled.span`
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0.3px;
  white-space: nowrap;
  color: ${({ theme }) => theme.baseBlue.a6};
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const StyledHeader = styled.header`
  background-color: ${({ theme }) => theme.baseBlue.a10};
  color: ${({ theme }) => theme.white.a9};
  font-size: 2em;
  box-shadow: none;
  position: relative;
  z-index: 999;

  &.new-login {
    background-color: ${({ theme }) => theme.white.a10};
    color: ${({ theme }) => theme.baseBlue.a6};
    box-shadow: -9px -5px 20px 0 rgba(51, 47, 35, 1);

    ${LogoLink} {
      float: left;
    }

    &.logo-only {
      ${LogoLink} {
        display: flex;
        justify-content: center;
        float: none;
      }

      ${HeaderImg} {
        margin-left: 0;
        margin-right: 0;
      }
    }
  }
`;
